import { useEffect } from "react";

export const Seo = ({ title, description, schemas = [] }) => {
  const schemasKey = JSON.stringify(schemas);

  useEffect(() => {
    if (title) document.title = title;

    let metaDescription = document.querySelector('meta[name="description"]');
    if (description) {
      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.setAttribute("name", "description");
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute("content", description);
    }

    const scriptTags = schemas.map((schema) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      scriptTags.forEach((script) => document.head.removeChild(script));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, schemasKey]);

  return null;
};

export default Seo;
